/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo, useEffect } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  // getPFuelCodeAtOtherCosts,
  deleteOtherCosts,
  saveOtherCosts,
  retrieveOtherCosts,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getClientInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber, Select } from 'antd'
import { ErrorContext, PNodeZoneContext } from 'context'
import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'
import * as R from 'ramda'
import { toSelectionColProps } from '@integec/grid-tools'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import { getPFuelCodeForOtherCostByClients } from 'marginanalysis/utils'
import { KINDLE_CLIENT } from 'client'

const title = 'Other Costs'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pFuelCode',
    display: 'PFuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(pFuelCodeChioce),
  }),
  numCol({
    ident: 'handlingCost',
    display: 'Handling Cost',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'chemicalCost',
    display: 'Chemical Cost',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'emissionCost',
    display: 'Emission Cost',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'omCost',
    display: 'Om Cost',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'otherCost',
    display: 'Other Cost',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const OtherCosts = ({ CLIENT, targetInfo, envConfig, actionPermits }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const [pFuelCodeMap, setPFuelCodeMap] = useState({})

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )
  const headerWithFormatter = useMemo(
    _ => {
      const curHeaders = CLIENT === KINDLE_CLIENT ? KindleHeaders : headers
      return curHeaders.map(header =>
        header.ident === 'unitId' || header.ident === 'unitid'
          ? {
              ...header,
              dataFormatter: ({ value }) =>
                value +
                  (emktIdUnitNameMap[value]
                    ? ' - ' + emktIdUnitNameMap[value]
                    : '') || value,
              // dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                emktIdUnitNameMap[rowData.unitId] ||
                emktIdUnitNameMap[rowData.unitid] ||
                rowData.unitId ||
                rowData.unitid,
            }
          : header.ident === 'pFuelCode'
          ? {
              ...header,
              ...toSelectionColProps(pFuelCodeMap),
              dataFormatter: ({ value }) =>
                value + ' - ' + pFuelCodeMap[value] || value,
              alignment: 'left',
            }
          : header
      )
    },
    [CLIENT, emktIdUnitNameMap, pFuelCodeMap]
  )

  const headerMap = useMemo(
    _ =>
      R.compose(
        R.fromPairs,
        R.map(({ ident, display }) => [ident, display])
      )(headerWithFormatter),
    [headerWithFormatter]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow style={{ padding: '5px', paddingLeft: '10px' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '180px 150px 200px 150px 120px 150px 100px 180px 150px 150px',
          gridGap: '5px',
        }}
      >
        <Label>Unit :</Label>
        <div style={{ gridColumn: 'span 3' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
            showX2X3={false}
          />
        </div>
        <Label>Effective Date :</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>PFuel Code :</Label>
        <Select
          value={insertData.pFuelCode}
          onChange={value => setInsertData({ ...insertData, pFuelCode: value })}
          style={{ width: '100%' }}
        >
          {Object.keys(pFuelCodeMap).map(m => (
            <Select.Option key={m} value={m}>
              {m === pFuelCodeMap[m] ? m : m + ' - ' + pFuelCodeMap[m]}
            </Select.Option>
          ))}
        </Select>
        <Label>{headerMap.handlingCost} :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.handlingCost}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, handlingCost: value })
          }
        />
        <Label>{headerMap.chemicalCost} :</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.chemicalCost}
          onChange={value =>
            setInsertData({ ...insertData, chemicalCost: value })
          }
        />
        <Label>{headerMap.emissionCost} :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.emissionCost}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, emissionCost: value })
          }
        />
        <Label>{headerMap.omCost} :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.omCost}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, omCost: value })}
        />
        <Label>Other Cost :</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.otherCost}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, otherCost: value })}
        />
        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  useEffect(
    _ => {
      // getPFuelCodeAtOtherCosts(targetInfo).fork(setError, data => {
      //   const pFuelCodeMap = R.fromPairs(
      //     data.map(d => [d.pFuelCode, d.pFuelCode])
      //   )
      //   setPFuelCodeMap(pFuelCodeMap)
      // })
      getPFuelCodeForOtherCostByClients({
        targetInfo,
        CLIENT: envConfig.clientId,
        setError,
        setPFuelCodeMap,
      })
    },
    [envConfig.clientId, setError, targetInfo]
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        withDatePickerTitle="Effective Date : "
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker
        title={title}
        header={headerWithFormatter}
        saveTask={saveOtherCosts}
        retrieveTask={retrieveOtherCosts}
        deleteTask={deleteOtherCosts}
        altBy={u => u.unitId}
        sortOptions={headers}
        initialSortOptions={headers}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
        withImport
        importUrl="marginanalysisdata-import/generic-import"
        importData={{ importType: 'MA_OTHER_COSTS' }}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(OtherCosts)

const KindleHeaders = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'pFuelCode',
    display: 'PFuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(pFuelCodeChioce),
  }),
  numCol({
    ident: 'handlingCost',
    display: 'Handling Cost (N/A)',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'chemicalCost',
    display: 'Chemical Cost ($/MWh)',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'emissionCost',
    display: 'Emission Cost ($/MMBtu)',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'omCost',
    display: 'OM Cost (N/A)',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'otherCost',
    display: 'Other Cost',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]
